export const GIT_COMMIT = 'f7ff068a647466ea154dced95505921b8c6c2c85'
